import { store } from '../store/store';
import { selectTenantId } from '../pages/configuration/participantSignupSlice';

function getBootstrapTenantToken(): string {
  return (
    sessionStorage.getItem('tenantToken') ||
    localStorage.getItem('tenantToken') ||
    ''
  );
}

export function getTenantId(): string {
  return selectTenantId(store.getState()) ?? getBootstrapTenantToken();
}
